<template>
  <savings-deposit-upsell-modal
    v-if="tryShowModal"
  />
</template>

<script>
import { mapState } from 'pinia'
import { useRootStore } from '@/store/root'
import SavingsDepositUpsellModal from './SavingsDepositUpsellModal.vue'

export default {
  name: 'savings-deposit-upsell-wrapper',
  components: {
    SavingsDepositUpsellModal
  },
  computed: {
    ...mapState(useRootStore, [
      'isLoggedIn',
      'featureFlags',
      'transactionsAreAllowed',
      'confirmAccountDataForTransactions',
      'onboardForTransactions',
      'isCustomer',
      'areTermsAccepted',
      'openSavingDepositModal',
      'shouldRedirectToCurrentAccountOpenFlow',
      'isCustomerInitially'
    ]),
    tryShowModal () {
      return this.isLoggedIn &&
        this.isCustomerInitially === true &&
        this.isCustomer &&
        this.areTermsAccepted &&
        !this.openSavingDepositModal.isVisible &&
        !this.shouldRedirectToCurrentAccountOpenFlow &&
        this.featureFlags.myDeposits && // from URL_MY_DEPOSITS route path beforeEnter guard in src/views/index.js; ideally both places would use the same function to determine this
        (this.transactionsAreAllowed || this.confirmAccountDataForTransactions || this.onboardForTransactions) && // from transactionalRouteGuard used in modules/deposits/views/index.js
        this.featureFlags.enableDemandDeposits &&
        this.featureFlags.savingsDepositUpsellModal
    }
  }
}
</script>
